"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_THEME = exports.DEFAULT_LANGUAGE = exports.THEME_PREFERENCES = exports.SUPPORTED_LANGUAGES = void 0;
/**
 * User-settings vocabulary shared across every bounded context that reads or
 * writes a user's interface preferences (frontend i18n, backend persistence,
 * backend RFC 9457 localization). Mirrors `scope-type.ts`'s precedent: a
 * single authoritative `as const` array plus a derived union type, consumed
 * by both `products/console-web` and `platform/core-api` rather than
 * duplicated as separate literal arrays in each.
 */
exports.SUPPORTED_LANGUAGES = ['it', 'en'];
exports.THEME_PREFERENCES = ['light', 'dark', 'system'];
exports.DEFAULT_LANGUAGE = 'it';
exports.DEFAULT_THEME = 'system';
//# sourceMappingURL=user-settings.js.map